module.exports = __webpack_public_path__ + "banner.cf068cc8.png";